
<footer id="sticky">
  <div class="disclaimer">{{'' | i18n: 'disclaimer'}}</div>
  <div class="footer-content-copyright">&copy; BMW. {{'' | i18n: 'all-rights-reserved'}}.</div>
</footer>
